import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, onMounted, ref, watch } from 'vue-demi';
import { AbIcon } from '..';

interface Props {
  navigation?: boolean;
  scrollbar?: boolean;
  pagination?: boolean;
  autoplay?: boolean;
  speed?: number;
  loop?: boolean;
  lazy?: boolean;
  slidesPerView?: number | 'auto';
  spaceBetween?: number;
  observer?: boolean;
  options?: Record<string, any>;
  blurNotFullyVisibleSlides?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbSlider',
  props: {
    navigation: { type: Boolean, default: false },
    scrollbar: { type: Boolean, default: false },
    pagination: { type: Boolean, default: false },
    autoplay: { type: Boolean, default: false },
    speed: { default: 400 },
    loop: { type: Boolean, default: false },
    lazy: { type: Boolean, default: true },
    slidesPerView: { default: 1 },
    spaceBetween: { default: 0 },
    observer: { type: Boolean, default: false },
    options: { default: undefined },
    blurNotFullyVisibleSlides: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { navigation: boolean, scrollbar: boolean, pagination: boolean, autoplay: boolean, speed: number, loop: boolean, lazy: boolean, slidesPerView: number | 'auto', spaceBetween: number, observer: boolean, options: Record<string, any>, blurNotFullyVisibleSlides: boolean };



const paginationOptions = {
  dynamicBullets: true,
};
const scrollbarOptions = {
  dragSize: 180,
  snapOnRelease: true,
};
const lazyOptions = {
  checkInView: true,
  loadPrevNext: true,
  loadOnTransitionStart: true,
};
const autoplayOptions = {
  delay: 3000,
  pauseOnMouseEnter: true,
};

const mounted = ref(false);
const loaded = ref(false);

const swiperOptions = computed(() => {
  if (!props.options)
    return {
      observer: true,
      spaceBetween: props.spaceBetween,
      slidesPerView: props.slidesPerView,
      speed: props.speed,
      loop: props.loop,
      pagination: { ...paginationOptions, enabled: props.pagination },
      scrollbar: props.scrollbar
        ? {
            enabled: true,
            draggable: true,
          }
        : false,
      autoplay: props.autoplay && autoplayOptions,
      navigation: props.navigation,
      lazy: { ...lazyOptions, enabled: props.lazy },
      isDuplicate: false,
      watchSlidesProgress: props.blurNotFullyVisibleSlides,
    };
  return props.options;
});

const slider = ref<any>(null);
const slideNext = () => {
  slider.value?.swiper.slideNext();
};
const slidePrev = () => {
  slider.value?.swiper.slidePrev();
};

onMounted(async () => {
  mounted.value = true;
  await nextTick();

  if (!slider.value) return;

  Object.assign(slider.value, swiperOptions.value);

  slider.value.initialize();
  loaded.value = true;
});

expose({
  slideNext,
  slidePrev,
  swiper: computed(() => slider.value?.swiper),
});

return { __sfc: true,props, paginationOptions, scrollbarOptions, lazyOptions, autoplayOptions, mounted, loaded, swiperOptions, slider, slideNext, slidePrev, AbIcon }
}

})